import { jsxs as s, jsx as t } from "react/jsx-runtime";
const n = "Fechar Explicação", e = "Legal, Entendi", d = ({
  isFirstStep: i,
  isLastStep: r,
  onClose: o,
  onPrevious: c,
  onNext: l
}) => /* @__PURE__ */ s("div", { className: "tooltip-footer", children: [
  i ? /* @__PURE__ */ t("button", { onClick: () => o(n), children: n }) : /* @__PURE__ */ t("button", { onClick: c, children: "< Anterior" }),
  r ? /* @__PURE__ */ t("button", { onClick: () => o(e), children: e }) : /* @__PURE__ */ t("button", { onClick: l, children: "Próximo >" })
] });
export {
  d as TooltipFooter
};
